<template>
	<div
	class="o-separator"
		:class="`${direction}`"
		aria-hidden="true"
	>
		<div class="o-separator__line" />
	</div>
</template>

<script>
export default {
	name: "OpreSeparator",
	props: {
		direction: {
			type: String,
			default: "horizontal",
		},
	},
};
</script>

<style lang="scss" scoped>
	.o-separator {
		display: inline-flex;
		.o-separator__line {
			background-color: $o-color-border-separator;
		}

		&.horizontal {
			width: 100%;
			padding: 16px 0;
			.o-separator__line {
				height: 1px;
				width: 100%;
			}
		}
		&.vertical {
			flex-direction: column;
			padding: 0 16px;
			height: 100%;

			.o-separator__line {
				width: 1px;
				height: 100%;
			}
		}
	}
</style>
